import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useCartStore, selectTotalItems } from '@store/useCartStore'
import CartDrawer from './CartDrawer'
import './Navbar.scss'

export default function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const totalItems = useCartStore(selectTotalItems)
  const location = useLocation()

  const isAdmin = location.pathname.startsWith('/admin')
  if (isAdmin) return null

  return (
    <>
      <nav className="navbar">
        <Link to="/" className="nav-logo">
          <img
            src="/logo-miss-lemon.png"
            alt="Miss Lemon Candles"
            className="nav-logo__img"
            width={200}
            height={56}
            decoding="async"
          />
        </Link>

        <div className="nav-links">
          <Link to="/shop">Produse</Link>
          <a href="/#despre">Despre noi</a>
          <a href="/#recenzii">Recenzii</a>
          <a href="/#contact">Contact</a>
        </div>

        <div className="nav-actions">
          <button
            className="nav-cart"
            onClick={() => setDrawerOpen(true)}
            aria-label="Coș de cumpărături"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
            {totalItems > 0 && <span className="nav-cart-badge">{totalItems}</span>}
          </button>
          <Link to="/shop" className="nav-cta">Cumpără acum</Link>
        </div>
      </nav>

      <CartDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  )
}
